/** 权限网关 — 包裹路由内容，无对应权限跳转 /403 */

import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAppContext } from '@/contexts/AppContext';

interface PermissionGateProps {
  /** 需要的权限码，如 system:user:list；为空表示无需校验 */
  perm?: string;
  children: ReactNode;
}

export default function PermissionGate({ perm, children }: PermissionGateProps) {
  const { permissions } = useAppContext();

  if (perm && !permissions.includes(perm) && !permissions.includes('*:*')) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
}
